import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button, ButtonToolbar, DropdownButton, MenuItem} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, DateTimePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number, ToggleButton} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import ClientLookup from '../../components/Form/ClientLookup';
import Client from '../../helpers/ApiClient';
import Renderers from "../../helpers/Renderers";
import ProgrammeList from "../Programme/PickerList";
import ModalWindow from "../../reactis/reactis-modal/src/ModalWindow";
import DriverList from "./PickerList";
import EventEmitter from "../../EventEmitter";


@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid),
			identity: state.auth.identity,
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'driver.fetch',
			save: 'driver.save',
			remove: 'driver.delete'
		};

		this.changeEvent = 'driver.change';

		this.messages = {
			remove: 'Opravdu si přejete řidiče odstranit?',
			notfound: 'Řidič nenalezen!'
		};

		this.schema = {
			ev: {
				class: TextInput,
				label: 'Evidenční číslo',
				rules: {
					presence: {message: 'Evidenční číslo je povinná položka!'},
					numericality: {
						message: 'Hodnota musí být číslo!'
					}
				}
			},
			surname: {
				class: TextInput,
				label: 'Příjmení',
				autoFocus: !props.id,
				rules: {
					presence: {message: 'Příjmení je povinná položka!'}
				}
			},
			name: {
				class: TextInput,
				label: 'Jméno',
				rules: {
					presence: {message: 'Jméno je povinná položka!'}
				}
			},
			born: {
				class: DatePicker,
				label: 'Datum narození'
			},
            email: {
                class: TextInput,
                label: 'E-mail'
            },
            phone: {
                class: TextInput,
                label: 'Telefon'
            },
			image: {
				class: ImageUpload,
				label: 'Foto'
			},
			client: {
				class: ClientLookup,
				addButton: true,
				value: props.firm ? props.firm : null,
				label: 'Firma'
			},
      personal_number: {
        class: TextInput,
        label: 'Osobní číslo'
      },
			op_number: {
				class: TextInput,
				label: 'Číslo OP'
			},
			nationality: {
				class: TextInput,
				label: 'Národnost',
				value: 'CZ'
			},
			omv_number: {
				class: TextInput,
				label: 'Průkaz OMV'
			},
			omv_issued: {
				class: DatePicker,
				label: 'Datum vydání',
        rules: (val, form) => {
          if (form.omv_number && form.omv_number.length && form.omv_number.length > 0) {
            return {
              presence: {message: 'Datum vydání je povinná položka!'}
            }
          }
        }
			},
			omv_expired: {
				class: DatePicker,
				label: 'Platnost do'
			},
			rmv_number: {
				class: TextInput,
				label: 'Průkaz ŘMV',
                style: {width: 100}
			},
			rmv_group: {
				class: TextInput,
				label: 'Skupina',
                style: {width: 100}
			},
			instructor: {
				class: TextInput,
				label: 'Instruktor'
			},
			issue: {
				class: TextInput,
				label: 'Vydal',
				value: this.props.identity.title
			},
			register: {
				class: TextInput,
				label: 'Eviduje',
				value: 'Tolex spol.s.r.o.'
			},
			active: {
				class: Checkbox,
				label: 'Přístup do e-školení'
			},
			credit_to: {
				class: DatePicker,
				label: 'Zápočet do'
			},
      password: {
        class: TextInput,
        type: 'password',
        label: 'Heslo',
        visible: (form) => {
          return form.active
        }
      },
      passwordConfirm: {
        class: TextInput,
        type: 'password',
        label: 'Heslo pro kontrolu',
        visible: (form) => {
          return form.active
        },
        rules: {
          equality: {
            attribute: 'password',
            message: 'Hesla se musejí shodovat!'
          }
        }
      },
			files: {
				class: FileUpload,
				label: 'Přílohy'
			},
			notice: {
				class: TextInput,
				label: 'Poznámka'
			},

			op_a_1: {
				class: ToggleButton,
				title: 'A',
			},
			op_b_1: {
				class: ToggleButton,
				title: 'B',
			},
			op_c_1: {
				class: ToggleButton,
				title: 'C',
			},
			op_d_1: {
				class: ToggleButton,
				title: 'D',
			},
			op_e_1: {
				class: ToggleButton,
				title: 'E',
			},
			op_f_1: {
				class: ToggleButton,
				title: 'F',
			},
			op_g_1: {
				class: ToggleButton,
				title: 'G',
			},
			op_w1_1: {
				class: ToggleButton,
				title: 'W1',
			},
			op_w2_1: {
				class: ToggleButton,
				title: 'W2',
			},
			op_m_1: {
				class: ToggleButton,
				title: 'M',
			},
			op_z_1: {
				class: ToggleButton,
				title: 'Z',
			},
			op_a_2: {
				class: ToggleButton,
				title: 'A',
			},
			op_b_2: {
				class: ToggleButton,
				title: 'B',
			},
			op_c_2: {
				class: ToggleButton,
				title: 'C',
			},
			op_d_2: {
				class: ToggleButton,
				title: 'D',
			},
			op_e_2: {
				class: ToggleButton,
				title: 'E',
			},
			op_f_2: {
				class: ToggleButton,
				title: 'F',
			},
			op_g_2: {
				class: ToggleButton,
				title: 'G',
			},
			op_w1_2: {
				class: ToggleButton,
				title: 'W1',
			},
			op_w2_2: {
				class: ToggleButton,
				title: 'W2',
			},
			op_m_2: {
				class: ToggleButton,
				title: 'M',
			},
			op_z_2: {
				class: ToggleButton,
				title: 'Z',
			},

			ext_op_a_1: {
				class: ToggleButton,
				title: 'A',
			},
			ext_op_b_1: {
				class: ToggleButton,
				title: 'B',
			},
			ext_op_c_1: {
				class: ToggleButton,
				title: 'C',
			},
			ext_op_d_1: {
				class: ToggleButton,
				title: 'D',
			},
			ext_op_e_1: {
				class: ToggleButton,
				title: 'E',
			},
			ext_op_f_1: {
				class: ToggleButton,
				title: 'F',
			},
			ext_op_g_1: {
				class: ToggleButton,
				title: 'G',
			},
			ext_op_w1_1: {
				class: ToggleButton,
				title: 'W1',
			},
			ext_op_w2_1: {
				class: ToggleButton,
				title: 'W2',
			},
			ext_op_m_1: {
				class: ToggleButton,
				title: 'M',
			},
			ext_op_z_1: {
				class: ToggleButton,
				title: 'Z',
			},
			ext_op_a_2: {
				class: ToggleButton,
				title: 'A',
			},
			ext_op_b_2: {
				class: ToggleButton,
				title: 'B',
			},
			ext_op_c_2: {
				class: ToggleButton,
				title: 'C',
			},
			ext_op_d_2: {
				class: ToggleButton,
				title: 'D',
			},
			ext_op_e_2: {
				class: ToggleButton,
				title: 'E',
			},
			ext_op_f_2: {
				class: ToggleButton,
				title: 'F',
			},
			ext_op_g_2: {
				class: ToggleButton,
				title: 'G',
			},
			ext_op_w1_2: {
				class: ToggleButton,
				title: 'W1',
			},
			ext_op_w2_2: {
				class: ToggleButton,
				title: 'W2',
			},
			ext_op_m_2: {
				class: ToggleButton,
				title: 'M',
			},
			ext_op_z_2: {
				class: ToggleButton,
				title: 'Z',
			},
			op_z_text: {
				class: TextArea,
				style: {height: 70},
				label: 'Z'
			},
			ext_op_z_text: {
				class: TextArea,
				style: {height: 70},
				label: 'Z'
			},
			/*agree_date: {
				class: DateTimePicker,
				label: 'Souhlas se zprac.'
			},*/
		};
		this.form = new FormManager(this.schema);
		if (!props.id) {
			const client = new Client();
			client.call('driver.getDefaults').then((data) => {
				this.form.setValue(data);
			});
		}
	}

	componentDidMount() {
		this.form.on('change', (key, value, values) => {
			if (key == 'name' || key == 'surname') {
				this.title = (values.get('surname') ? values.get('surname') : '') + ' ' +
					(values.get('name') ? values.get('name') : '');
			}
			this.changed = true;
		});
		super.componentDidMount();
		if (this.props.popup) {
			this.form.reset();
		}

	}

	updateTab(data) {
		this.props.updateTab({title: data.surname + ' ' + data.name});

	}

	onSave(data) {
		if (this.props.onSave) {
			this.form.reset();
			this.props.onSave(data);
		}
	}

	handlePrint(type) {
		const api = new Client();
		api.call('driver.download', {id: this.props.id, type}, {progress: true}).then((data) => {
			if (data) {
				var win = window.open(data.url, '_blank');
				if(win) {
					win.focus();
				} else{
					alert('Povolte prosím v prohlížeči vyskakovací okna pro tuto aplikaci.');
				}
			}
		});
	};

	handleClearExt(e) {
		e.preventDefault();
		this.form.setValue({
			ext_op_a_1: false,
			ext_op_b_1: false,
			ext_op_c_1: false,
			ext_op_d_1: false,
			ext_op_e_1: false,
			ext_op_f_1: false,
			ext_op_g_1: false,
			ext_op_w1_1: false,
			ext_op_w2_1: false,
			ext_op_m_1: false,
			ext_op_z_1: false,
			ext_op_a_2: false,
			ext_op_b_2: false,
			ext_op_c_2: false,
			ext_op_d_2: false,
			ext_op_e_2: false,
			ext_op_f_2: false,
			ext_op_g_2: false,
			ext_op_w1_2: false,
			ext_op_w2_2: false,
			ext_op_m_2: false,
			ext_op_z_2: false,
			ext_op_z_text: ''
		});
	}

	handleMoveExt(e) {
		this.form.setValue({
			op_a_1: this.form.getValues().get('op_a_1') || this.form.getValues().get('ext_op_a_1'),
			op_b_1: this.form.getValues().get('op_b_1') || this.form.getValues().get('ext_op_b_1'),
			op_c_1: this.form.getValues().get('op_c_1') || this.form.getValues().get('ext_op_c_1'),
			op_d_1: this.form.getValues().get('op_d_1') || this.form.getValues().get('ext_op_d_1'),
			op_e_1: this.form.getValues().get('op_e_1') || this.form.getValues().get('ext_op_e_1'),
			op_f_1: this.form.getValues().get('op_f_1') || this.form.getValues().get('ext_op_f_1'),
			op_g_1: this.form.getValues().get('op_g_1') || this.form.getValues().get('ext_op_g_1'),
			op_w1_1: this.form.getValues().get('op_w1_1') || this.form.getValues().get('ext_op_w1_1'),
			op_w2_1: this.form.getValues().get('op_w2_1') || this.form.getValues().get('ext_op_w2_1'),
			op_m_1: this.form.getValues().get('op_m_1') || this.form.getValues().get('ext_op_m_1'),
			op_z_1: this.form.getValues().get('op_z_1') || this.form.getValues().get('ext_op_z_1'),

			op_a_2: this.form.getValues().get('op_a_2') || this.form.getValues().get('ext_op_a_2'),
			op_b_2: this.form.getValues().get('op_b_2') || this.form.getValues().get('ext_op_b_2'),
			op_c_2: this.form.getValues().get('op_c_2') || this.form.getValues().get('ext_op_c_2'),
			op_d_2: this.form.getValues().get('op_d_2') || this.form.getValues().get('ext_op_d_2'),
			op_e_2: this.form.getValues().get('op_e_2') || this.form.getValues().get('ext_op_e_2'),
			op_f_2: this.form.getValues().get('op_f_2') || this.form.getValues().get('ext_op_f_2'),
			op_g_2: this.form.getValues().get('op_g_2') || this.form.getValues().get('ext_op_g_2'),
			op_w1_2: this.form.getValues().get('op_w1_2') || this.form.getValues().get('ext_op_w1_2'),
			op_w2_2: this.form.getValues().get('op_w2_2') || this.form.getValues().get('ext_op_w2_2'),
			op_m_2: this.form.getValues().get('op_m_2') || this.form.getValues().get('ext_op_m_2'),
			op_z_2: this.form.getValues().get('op_z_2') || this.form.getValues().get('ext_op_z_2'),

			op_z_text: this.form.getValues().get('op_z_text') + this.form.getValues().get('ext_op_z_text')
		});
		this.handleClearExt(e);

	}

	handleMergeDriver(row) {
		this.popupDriver.hide();
		const confirm = new ConfirmWindow('Potvrzení', 'Opravdu si přejete řidiče sloučit do řidiče '+row.name+' '+row.surname+'?');
		confirm.show(this.context.store.dispatch, () => {
			const api = new Client();
			api.call('driver.merge', {id: this.props.id, to: row.id}, {progress: true}).then((result) => {
				if (!result.error) {
					this.context.flashMessage({message: 'Řidič byl sloučen.'});
					this.props.closeTab();
					this.props.tabActions.openTabForm('driver', '', {id: row.id});
					EventEmitter.emit(this.changeEvent);
				}
			});
		});

	}

  actionRegister() {
    const api = new Client();
    api.call('driver.getRegisterUrl', {id: this.props.id}, {progress: false}).then((result) => {
      if (!result.error) {
        window.location.href = result.url;

      }
    });
  }

	showMerge() {
		const data = this.form.getValues().toJS();
		this.popupDriver = new ModalWindow(null, <DriverList title="Vyberte řidiče, do kterého budete slučovat" defaultFilter={{name: data.name, surname: data.surname}} defaultFixedFilter={{notid: this.props.id}} onAdd={(row) => this.handleMergeDriver(row)} />);
		this.popupDriver.className = 'wide950';
		this.popupDriver.show(this.context.store.dispatch);
	}

	render() {
		const data = this.props.form &&  this.props.form.get('data')  ? this.props.form.get('data').toJS() : {};
    data.active = !!this.form.getValues().get('active');
		const canEdit = true;
		const saveButton = <SaveButton
			disabled={!canEdit}
			loading={!!(this.props.form && this.props.form.get('saving'))}
			onClick={()=>this.save(true)}
		/>;

		const saveEditButton = <SaveButton
			title="Uložit a pokračovat v editaci"
			bsStyle="default"
			disabled={!canEdit}
			loading={!!(this.props.form && this.props.form.get('saving'))}
			onClick={()=>this.save()}
		/>;

		const saveNewButton = <SaveButton
			title="Uložit a nový"
			disabled={!canEdit}
			bsStyle="default"
			loading={!!(this.props.form && this.props.form.get('saving'))}
			onClick={()=>this.save()}
		/>;

		const printButton = (
			<DropdownButton id="print" style={{marginLeft:5}} bsStyle="success" title={<span><i className="fa fa-print  position-left" />Tisk</span>}>
				<MenuItem onSelect={() => this.handlePrint(1)} eventKey="1">Průkaz EU</MenuItem>
				<MenuItem onSelect={() => this.handlePrint(4)} eventKey="1">Průkaz podnikový</MenuItem>
				<MenuItem onSelect={() => this.handlePrint(2)} eventKey="2">Evidenční list</MenuItem>
				<MenuItem onSelect={() => this.handlePrint(3)} eventKey="3">Potvrzení o opakovaném školení</MenuItem>
			</DropdownButton>
		);



		const btns = <ButtonToolbar>
			{saveButton}
			{saveEditButton}
			{saveNewButton}
      {this.props.id > 0 && <ActionButton disabled={!canEdit} icon="fa fa-user" onClick={()=>this.actionRegister()}>
        Registrace
      </ActionButton>}
			{this.props.id > 0 && <ActionButton disabled={!canEdit} icon="fa fa-user-plus" onClick={()=>this.showMerge()}>
				Sloučit
			</ActionButton>}
			{this.props.id > 0 && <ActionButton disabled={!canEdit} bsStyle="danger" icon="fa fa-trash-o" onClick={()=>this.remove()}>
				Odstranit
			</ActionButton>}
			{this.props.id > 0 && printButton}
		</ButtonToolbar>;

		const zActive = this.form.getValues().get('op_z_1') || this.form.getValues().get('op_z_2');
		const ezActive = this.form.getValues().get('ext_op_z_1') || this.form.getValues().get('ext_op_z_2');

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					{!this.props.popup && <Toolbar title="Řidič" buttons={btns} />}
					<div className="row">
						<div className="col-xs-6">
							<table className="form">
								<tbody>
								<FormRow name="ev" labelWidth={135} />
								<FormRow name="surname"  />
								<FormRow name="name" />
								<FormRow name="born" />
                                <FormRow name="email" />
                                <FormRow name="phone" />
								<FormRow name="client" />
                <FormRow name="personal_number" />
								<FormRow name="omv_number" />
								<FormRow name="omv_issued" />
								<FormRow name="omv_expired"/>
								<tr className="divider">
									<td colSpan="2"></td>
								</tr>
								<tr>
									<th>Průkaz ŘMV</th>
									<td>číslo <FormField name="rmv_number"/> skupina <FormField name="rmv_group" /></td>
								</tr>
								<tr className="divider">
									<td colSpan="2"></td>
								</tr>
								<FormRow name="op_number"/>
								<FormRow name="nationality" />
								<FormRow name="notice" />
								<FormRow name="active" />
                {data.active && <FormRow name="password" />}
                {data.active && <FormRow name="passwordConfirm" />}
				{data.active && <FormRow name="credit_to" />}
								{data.agree_date &&
								<tr>
									<th>Souhlas se zprac.</th>
									<td>
										{Renderers.DateTime(data.agree_date)}
									</td>
								</tr>}
                <FormRow name="files" />
								</tbody>
							</table>
						</div>
						<div className="col-xs-6">
							{false && <fieldset>
								<legend>Oprávnění</legend>
								<table className="form toggles">
									<tbody>
									<tr>
										<th>Třída</th>
										<td><FormField name="op_1"/> <FormField name="op_2"/> </td>
									</tr>
									<tr>
										<th>Skupina</th>
										<td>
											<FormField name="op_a"/> <FormField name="op_b"/> <FormField name="op_c"/> <FormField name="op_d"/> <FormField name="op_e"/> <FormField name="op_f"/> <FormField name="op_g"/> 											<FormField name="op_w1"/> <FormField name="op_w2"/> <FormField name="op_m"/> <FormField name="op_z"/>
										</td>
									</tr>
									<tr>
										<th></th>
										<td>
											{zActive &&
											<div style={{marginTop:5}}>
												<FormField name="op_z_text"/>
											</div>}
										</td>
									</tr>
									</tbody>

								</table>
							</fieldset>}

							{false && <fieldset>
								<legend><div style={{float:'right', textTransform: 'none'}}><a href="#" onClick={(e) => this.handleClearExt(e)}>vymazat</a> | <a href="#" onClick={(e) => this.handleMoveExt(e)}>přesnést do oprávnění</a></div> Rozšíření</legend>
								<table className="form toggles">
									<tbody>
									<tr>
										<th>Třída</th>
										<td><FormField name="ext_op_1"/> <FormField name="ext_op_2"/> </td>
									</tr>
									<tr>
										<th>Skupina</th>
										<td>
											<FormField name="ext_op_a"/> <FormField name="ext_op_b"/> <FormField name="ext_op_c"/> <FormField name="ext_op_d"/> <FormField name="ext_op_e"/> <FormField name="ext_op_f"/> <FormField name="ext_op_g"/> <FormField name="ext_op_w1"/> <FormField name="ext_op_w2"/> <FormField name="ext_op_m"/> <FormField name="ext_op_z"/>
										</td>
									</tr>
									<tr>
										<th></th>
										<td>
											{ezActive &&
											<div style={{marginTop:5}}>
												<FormField name="ext_op_z_text"/>
											</div>}

										</td>
									</tr>
									</tbody>
								</table>
							</fieldset>}

							<fieldset>
								<legend>Oprávnění</legend>
								<table className="form toggles">
									<tbody>
										<tr>
											<th>Skupiny I.</th>
											<td>
												<FormField name="op_a_1"/> <FormField name="op_b_1"/> <FormField name="op_c_1"/> <FormField name="op_d_1"/> <FormField name="op_e_1"/> <FormField name="op_f_1"/> <FormField name="op_g_1"/> 											<FormField name="op_w1_1"/> <FormField name="op_w2_1"/> <FormField name="op_m_1"/> <FormField name="op_z_1"/>
											</td>
										</tr>
										<tr>
											<th>Skupiny II.</th>
											<td>
												<FormField name="op_a_2"/> <FormField name="op_b_2"/> <FormField name="op_c_2"/> <FormField name="op_d_2"/> <FormField name="op_e_2"/> <FormField name="op_f_2"/> <FormField name="op_g_2"/> 											<FormField name="op_w1_2"/> <FormField name="op_w2_2"/> <FormField name="op_m_2"/> <FormField name="op_z_2"/>
											</td>
										</tr>
										<tr>
											<th></th>
											<td>
												{zActive &&
												<div style={{marginTop:5}}>
													<FormField name="op_z_text"/>
												</div>}
											</td>
										</tr>
									</tbody>
								</table>
							</fieldset>
							<fieldset>
								<legend><div style={{float:'right', textTransform: 'none'}}><a href="#" onClick={(e) => this.handleClearExt(e)}>vymazat</a> | <a href="#" onClick={(e) => this.handleMoveExt(e)}>přesnést do oprávnění</a></div> Rozšíření</legend>
								<table className="form toggles">
									<tbody>
									<tr>
										<th>Skupiny I.</th>
										<td>
											<FormField name="ext_op_a_1"/> <FormField name="ext_op_b_1"/> <FormField name="ext_op_c_1"/> <FormField name="ext_op_d_1"/> <FormField name="ext_op_e_1"/> <FormField name="ext_op_f_1"/> <FormField name="ext_op_g_1"/> 											<FormField name="ext_op_w1_1"/> <FormField name="ext_op_w2_1"/> <FormField name="ext_op_m_1"/> <FormField name="ext_op_z_1"/>
										</td>
									</tr>
									<tr>
										<th>Skupiny II.</th>
										<td>
											<FormField name="ext_op_a_2"/> <FormField name="ext_op_b_2"/> <FormField name="ext_op_c_2"/> <FormField name="ext_op_d_2"/> <FormField name="ext_op_e_2"/> <FormField name="ext_op_f_2"/> <FormField name="ext_op_g_2"/> 											<FormField name="ext_op_w1_2"/> <FormField name="ext_op_w2_2"/> <FormField name="ext_op_m_2"/> <FormField name="ext_op_z_2"/>
										</td>
									</tr>
									<tr>
										<th></th>
										<td>
											{ezActive &&
											<div style={{marginTop:5}}>
												<FormField name="ext_op_z_text"/>
											</div>}

										</td>
									</tr>
									</tbody>
								</table>
							</fieldset>

							<fieldset>
								<legend>Průkaz</legend>
								<table className="form">
									<tbody>
									<FormRow name="image" />
									<FormRow name="instructor" />
									<FormRow name="issue" />
									<FormRow name="register" />
									</tbody>
								</table>
							</fieldset>
						</div>
					</div>

					{!this.props.popup &&
					<div style={{textAlign:'right'}}>
						{saveButton}
					</div>}

					{this.props.popup &&
					<div className="modal-footer" style={{margin: -20, marginTop: 20}}>
						<Button onClick={() => this.props.onClose()} bsStyle="link">Storno</Button>
						{saveButton}
					</div>}
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Driver/Form.js